__turbopack_context__.v({
  "icon": "StickyShare-module-scss-module__EmNHra__icon",
  "stickyShare": "StickyShare-module-scss-module__EmNHra__stickyShare",
});
